import dayjs from "@/utils/dayjsConfig";
import { isNumber, pickBy } from "lodash-es";
import { exportLift } from "@api";
import { QueryParams, MenuPath } from "@/facilities/model/user";
import { NA, FORMATDATE } from "@/enums/pageEnum";
import menu from "@/router/menu";

/// mock network wait
export const waitTime = (time: number = 100) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

// get
export const getUserLocalStorage = (name: string) => {
  try {
    const item = localStorage.getItem(name);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
};

export const getTimeToString = (date: number | null, nullStr?: string) => {
  return date && isNumber(date)
    ? dayjs(date).format(FORMATDATE)
    : nullStr || " ";
};

export const downloadTableData = (tableName: string, params: any) => {
  exportLift(tableName, params).then((res: any) => {
    const dataBlob = new Blob([`\ufeff${res.data}`], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(dataBlob);
    const downLoadBtto = document.createElement("a");
    downLoadBtto.href = url;
    downLoadBtto.download = `${tableName}(${dayjs(new Date().getTime()).format(
      "DD MMM YYYY h.mmA"
    )}).csv`;
    downLoadBtto.click();
    window.URL.revokeObjectURL(url);
  });
};

export const parseQueryString = (dateKeys?: QueryParams) => {
  const deUrl = decodeURIComponent(window.location.href);
  const query = deUrl?.split("?")[1];
  if (!query) return {};

  const params = new URLSearchParams(query);
  const result: any = {};
  params.forEach((value, key) => {
    if (value && key === "date" && value?.split(",").length) {
      const vals = value.split(",");
      result[dateKeys?.dateStart || "startTs"] = dayjs(
        vals[0],
        FORMATDATE
      ).valueOf();
      result[dateKeys?.dateEnd || "endTs"] = dayjs(
        vals[1],
        FORMATDATE
      ).valueOf();
      result[key] = [
        dayjs(vals[0], FORMATDATE) as any,
        dayjs(vals[1], FORMATDATE) as any,
      ];
      return;
    }
    result[key] = value;
  });
  return result;
};

export const getRedirectUri = (notParams?: boolean) => {
  const urls = new window.URL(window.location.href);
  const redirect = urls.searchParams.get("redirect");
  if (redirect) return redirect;
  const { pathname, search, hash } = window.location;
  let redirectUri = `${pathname}${search || hash}`;
  if (notParams) {
    const pathPasm = findMenuByPath(menu.routes || [], pathname);
    const path = new URLSearchParams(
      pickBy(pathPasm?.defaultParams || {})
    ).toString();
    redirectUri = `${pathname}${path ? `?${path}` : ""}`;
  }
  return encodeURIComponent(redirectUri);
};

export const getLiftNumberNA = (_: any, record: any) => {
  return getIsNumberNA(_, record) === NA ? NA : getTimeToString(_);
};

export const getIsNumberNA = (_: any, record: any) => {
  if (parseInt(record?.alarmLiftFaultNumber) === 0) return NA;
  return _;
};

export const OpenPrintFunc = (innerHTML: string) => {
  const button = document.createElement("button");
  button.textContent = "print";
  button.onclick = () => {
    document.body.innerHTML = innerHTML || "";
    document.body.setAttribute("class", "printContent");
    window.onafterprint = function () {
      window.close();
    };
    window.print();
  };
  button.click();
};

export const formaReportTable = (data: object[], byKey: string) => {
  const tempData: object[] = [];
  const groupedData = data.reduce((acc: any, item: any) => {
    if (!acc[item[byKey]] && item[byKey]) {
      acc[item[byKey]] = [];
    }
    if (item[byKey]) {
      acc[item[byKey]].push({ ...item, groupLift: false });
    }
    return acc;
  }, {});
  Object.keys(groupedData).map((key: string) => {
    const groupLift = groupedData[key];
    const grLift = { ...groupLift[0], id: key, groupLift: true };
    tempData.push(...[grLift, ...groupLift]);
  });
  return tempData;
};

export const parmsFromat = (params: any, pathname: string) => {
  if (!params) return pathname;
  const path = new URLSearchParams(pickBy(params)).toString();
  return `${pathname}?${encodeURIComponent(path)}`;
};

export const findMenuByPath = (menuPaths: MenuPath[], targetPath: string) => {
  const queue = [...menuPaths];
  while (queue.length > 0) {
    const current = queue.shift();
    if (current?.path === targetPath) {
      return current;
    }
    if (current?.routes || current?.child) {
      if (current?.routes) {
        queue.push(...current.routes);
      } else if (current?.child) {
        queue.push(...current.child);
      }
    }
  }
  return null;
};

export const getDaysInMonth = (year: number, month: number) => {
  return new Date(year, month + 1, 0).getDate();
};

export const parseMonth = (params: any) => {
  if (params && params.month) {
    const times = params.month?.split("/");
    params.month = `${times[1]}-${times[0]}`;
  }
  return params;
};
